import * as datepicker from "js-datepicker";

/**
 * Setup the datepicker
 */
export function initDatepicker(dateInput: HTMLInputElement): void {
    const currentDay = new Date();

    new datepicker(dateInput, {
        formatter: (input: HTMLInputElement, date: Date) => {
            // Months are 0 based, so we have to add one to get the proper month number
            const month = (date.getMonth() + 1).toString();
            const day = date.getDate().toString();
            const year = date.getFullYear();

            // padStart adds a leading zero
            input.value = `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
        },
        dateSelected: getValidDate(dateInput),
        // Set min date to tomorrow
        minDate: new Date(currentDay.setDate(currentDay.getDate() + 1)),
    });
}

/**
 * Gets a valid date from the input
 */
function getValidDate({ value }: HTMLInputElement) {
    let date = new Date(value);
    const currentDay = new Date();

    // Check to see if the returned date is NaN. If so set date to next month.
    if (Number.isNaN(date.getDate())) {
        date = new Date(currentDay.setMonth(currentDay.getMonth() + 1));
    }

    return date;
}
